import { Swiper } from 'swiper';
import { A11y, Pagination, Autoplay } from 'swiper/modules';
import { checkElementInView } from '../../../js/__utils/checkElementInView';

const sliders = document.querySelectorAll('.block-trip-hero .swiper');
const blocks = document.querySelectorAll('.block-trip-hero');

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const settings = {
			loop: true,
			grabCursor: false,
			spaceBetween: 0,
			slidesPerView: 1,
			modules: [A11y, Pagination, Autoplay],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			autoplay: {
				delay: 5000,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				dynamicBullets: true,
				dynamicMainBullets: 5,
			},
		};

		new Swiper(slider, settings);
	});
}

const outOfView = (target) => {
	target.classList.add('block-trip-hero--out-of-view');
};

const inView = (target) => {
	target.classList.remove('block-trip-hero--out-of-view');
};

if (blocks.length > 0) {
	blocks.forEach((block) => {
		checkElementInView(block, inView, outOfView, {
			root: null,
			rootMargin: `0px 0px 0px 0px`,
			threshold: [0],
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	const navElement = document.querySelector('.block-trip-hero__nav');
	const contentWrapper = document.querySelector('.main-footer');

	if (navElement && contentWrapper) {
		const navHeight = navElement.offsetHeight;
		contentWrapper.style.paddingBottom = `${navHeight}px`;
	}
});
